export const PageScoringHandler = {
  inferAndPersist() {},

  setup() {},

  getScore() {},
};
